const newsList = [{
        num: '74',
        homeImage: require('../assets/images/about/news/74/2.png'),
        titleNormal: '新九象、新使命、新气象！九象数字2023年中工作会议暨下半年营销工作部署会在深圳总部圆满召开！',
        titleSmall: '新九象、新使命、新气象！ \n' + '九象数字2023年中工作会议暨下半年营销工作部署会在深圳总部圆满召开！',
        year: '2023',
        month: '07',
        day: '08',
        content: [{
                type: 'text',
                content: ['回首疫情三年，企业发展变革的每一步都如履薄冰。公司战略的转移，是掌舵人的前瞻远瞩，是诸多九象员工的风雨同舟，并肩前行的硕果！事实证明，现阶段的企业部署铺排导向是正确的。更是勇敢的！\n' +
                    '本次大会在深圳总部召开，由九象董事长兼总经理周亮、华中区域总经理李黎、华南区域副总经理林孔亮、西南区域重庆分公司总经理李或、成都分公司熊智超及总部各部门管理干部参加此次会议。\n' +
                    '董事长兼总经理周亮更是对这三年来，支持企业发展战略的九象员工与各个广大客户表示衷心致谢！大疫之后的第一年，面对挑战与机遇，全体九象人上下齐心、力克艰难，努力推进公司各项既定目标任务的完成。'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/74/1.png'),
            },
            {
                type: 'text',
                content: ['对于下半年工作发展规划九象董事长兼总经理周亮提以下几点：\n',
                    '第一是提升管理水平 \n',
                    '建立公司内控管理制度；建立新的薪酬绩效体系；建设新的ERP订单系统。\n',
                    '第二是聚焦产品研发\n',
                    '继续推进工地安全警示教育系统的研发；全面提升动画视频产品的质量水平 。\n',
                    '第三是加强员工培训\n',
                    '加强管理人员的管理能力培训；加强基层员工的专业技能、职业化素养等多方面的培训。\n',
                    '第四是完善激励方案\n',
                    '完善独立核算机制、激励方案；推动阿米巴经营模式全面落地。'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/74/2.png'),
                imgTitle: '深圳总部会后留影'
            },
        ],
    }, {
        num: '73',
        homeImage: require('../assets/images/about/news/73/2.jpg'),
        titleNormal: '长沙理工大学土木工程学院举行2022年度九象教育奖学金颁奖典礼暨学生表彰大会',
        titleSmall: '长沙理工大学土木工程学院举行2022年度九象教育奖学金颁奖典礼暨学生表彰大会',
        year: '2023',
        month: '05',
        day: '09',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/73/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    }, {
        num: '71',
        homeImage: require('../assets/images/about/news/70/4.jpg'),
        titleNormal: '八一建军节！九象总部组织管理干部“学铁军精神，铸铁军忠魂，建铁军队伍”',
        titleSmall: '八一建军节！九象总部组织管理干部“学铁军精神，铸铁军忠魂，建铁军队伍”',
        year: '2022',
        month: '08',
        day: '01',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/70/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    }, {
        num: '72',
        homeImage: require('../assets/images/about/news/70/4.jpg'),
        titleNormal: '走进古田会议旧址，传承古田会议精神，锻造九象铁军之魂',
        titleSmall: '走进古田会议旧址，传承古田会议精神，锻造九象铁军之魂',
        year: '2022',
        month: '08',
        day: '30',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/70/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    }, {
        num: '70',
        homeImage: require('../assets/images/about/news/70/4.jpg'),
        titleNormal: '为目标加油，为梦想而战！九象数字2022年中工作会议在深圳总部圆满召开！',
        titleSmall: '为目标加油，为梦想而战！九象数字2022年中工作会议在深圳总部圆满召开！',
        year: '2022',
        month: '07',
        day: '11',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/70/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '69',
        homeImage: require('../assets/images/about/news/69/2.jpg'),
        titleNormal: '九象数字与深圳邦迪签署战略合作协议，共建全国首个建设工程监理安全管控平台',
        titleSmall: '九象数字与深圳邦迪签署战略合作协议，共建全国首个建设工程监理安全管控平台',
        year: '2022',
        month: '06',
        day: '30',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/69/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '68',
        homeImage: require('../assets/images/about/news/65/2.png'),
        titleNormal: '当危大工程有了先知，安全隐患就能有迹可循——九象《危大工程仿真交底系统》新品发布',
        titleSmall: '当危大工程有了先知，安全隐患就能有迹可循——九象《危大工程仿真交底系统》新品发布',
        year: '2022',
        month: '03',
        day: '20',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/68/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '67',
        homeImage: require('../assets/images/about/news/65/2.png'),
        titleNormal: '创新为先，内容为根，科技为魂|九象2021年工程智慧展厅/安全教育培训中心精彩呈现',
        titleSmall: '创新为先，内容为根，科技为魂|九象2021年工程智慧展厅/安全教育培训中心精彩呈现',
        year: '2022',
        month: '02',
        day: '25',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/67/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },

    {
        num: '66',
        homeImage: require('../assets/images/about/news/65/2.png'),
        titleNormal: '【喜讯】九象荣获"广东省专精特新企业"认定',
        titleSmall: '【喜讯】九象荣获"广东省专精特新企业"认定',
        year: '2021',
        month: '12',
        day: '24',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/66/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '64',
        titleNormal: '热烈欢迎深圳市建筑产业化协会陆荣秀会长一行莅临九象参观指导工作',
        titleSmall: '热烈欢迎深圳市建筑产业化协会陆荣秀会长一行莅临九象参观指导工作',
        year: '2021',
        month: '07',
        day: '23',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/64/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '63',
        titleNormal: '全国奋战，凝心聚力，驭势突破 | 九象数字2021年中工作会议在深圳总部圆满召开！',
        titleSmall: '九象数字2021年中工作会议在深圳总部圆满召开！',
        year: '2021',
        month: '07',
        day: '16',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/63/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '62',
        titleNormal: '【喜讯】|九象荣获CMMI3级国际标准认证，标志着九象研发实力获得国际权威认可。',
        titleSmall: '九象荣获CMMI3级国际标准认证！',
        year: '2021',
        month: '07',
        day: '09',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/62/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/62/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '61',
        homeImage: require('../assets/images/about/news/61/home.jpg'),
        titleNormal: '布局西南，扎根川渝|热烈祝贺九象数字重庆分公司隆重开业！',
        titleSmall: '布局西南，扎根川渝|热烈祝贺九象数字重庆分公司隆重开业！',
        year: '2021',
        month: '07',
        day: '06',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/61/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '60',
        homeImage: '',
        titleNormal: '祝贺|九象数字当选深圳市建筑产业化协会理事单位',
        titleSmall: '祝贺|九象数字当选深圳市建筑产业化协会理事单位',
        year: '2021',
        month: '06',
        day: '25',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/60/1.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=db582afe1e2044919d1d953161c18513'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/60/2.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=f905221cc71649faba79e6e641256bc8'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/60/3.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=da89c4b437754f709268aa4ab3e8a2fe'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/60/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '59',
        homeImage: '',
        titleNormal: '祝贺|九象数字科技荣获“广东省守合同重信用企业”称号',
        titleSmall: '祝贺|九象数字科技荣获“广东省守合同重信用企业”称号',
        year: '2021',
        month: '06',
        day: '23',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/59/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '58',
        homeImage: '',
        titleNormal: '布局华中，挺进武汉|九象再添新版图，热烈庆祝九象数字武汉分公司隆重开业！',
        titleSmall: '布局华中，挺进武汉|九象再添新版图，热烈庆祝九象数字武汉分公司隆重开业！',
        year: '2021',
        month: '05',
        day: '22',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/58/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '57',
        homeImage: '',
        titleNormal: '行业首创，震撼来袭，九象新品“工地安全教育3D立体影院”正式面向全国上市！',
        titleSmall: '行业首创，震撼来袭，九象新品“工地安全教育3D立体影院”正式面向全国上市！',
        year: '2021',
        month: '05',
        day: '19',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/57/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/6.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/7.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: require('../assets/images/about/news/57/sp1.mp4')
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/8.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: require('../assets/images/about/news/57/sp2.mp4')
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/57/9.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '56',
        homeImage: '',
        titleNormal: '加入我们,成就梦想|九象2021智慧工地+智慧安全+BIM动画三大事业部邀您共创大业！',
        titleSmall: '加入我们,成就梦想|九象2021智慧工地+智慧安全+BIM动画三大事业部邀您共创大业！',
        year: '2021',
        month: '04',
        day: '25',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/56/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/4.png'),
            },
            {
                type: 'text',
                content: ['九象2021全国火热招聘中，诚挚邀请您加入九象，携手共创大业。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/56/5.gif'),
            },
        ],
    },
    {
        num: '55',
        homeImage: '',
        titleNormal: '专业，专注，领跑16年，九象2020年工程动画视频业绩再攀新高，创意无限，精彩呈现!',
        titleSmall: '专业，专注，领跑16年，九象2020年工程动画视频业绩再攀新高，创意无限，精彩呈现!',
        year: '2021',
        month: '04',
        day: '20',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/55/1.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=ed0fcd40e584462e882ddcf5e099792b'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/55/1.1.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=0c4933ac9a7f45b89085cb697dda0b57'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/55/2.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=e685b688a1934138b6290cca28f57ca7'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/55/3.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=40439b135b234ec9a37d49824695dcb7'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/55/4.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.fantacg.com/ali-player.html?id=2eeba19fcb494906befe656c81fa5d02'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/55/5.png'),
            },
        ],
    },
    {
        num: '54',
        homeImage: '',
        titleNormal: '建筑港与九象数字在深圳签署战略合作协议，聚焦工程建设信息化领域开展深入合作',
        titleSmall: '建筑港与九象数字在深圳签署战略合作协议，聚焦工程建设信息化领域开展深入合作',
        year: '2021',
        month: '04',
        day: '16',
        content: [{
            type: 'image',
            url: require('../assets/images/about/news/54/1.png'),
        }, ],
    },
    {
        num: '53',
        homeImage: '',
        titleNormal: '2021年，九象这样干：定目标，追过程，拿结果',
        titleSmall: '2021年，九象这样干：定目标，追过程，拿结果',
        year: '2021',
        month: '03',
        day: '23',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/53/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/53/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/53/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/53/4.jpg'),
            },
        ],
    },
    {
        num: '52',
        homeImage: '',
        titleNormal: '九象铁军文化：九象铁军，王者之师，勇往直前，势不可挡',
        titleSmall: '九象铁军文化：九象铁军，王者之师，勇往直前，势不可挡',
        year: '2021',
        month: '03',
        day: '23',
        content: [{
                type: 'video',
                videoType: 'local',
                url: 'https://jiuxiang-guanwang.oss-cn-shenzhen.aliyuncs.com/%E5%B9%B4%E4%BC%9A.mp4?Expires=1619432387&OSSAccessKeyId=TMP.3KiuM1QAd6qAmXkZwreeqQfpavUgrPtMjXP6Xw51uHbrP3sRDjSx6a3AF3sEHLC1j6B5MMHMvBWoNeqtd8BSn1msSnMxFp&Signature=l7Rivo0TeP2J1Jv4y0bN6aEhNL0%3D&versionId=CAEQGRiBgMCukee1yBciIDRjZGM0ODUxM2QwODRjZjU5ZDRlNzhlNzYzOTYzY2Nj&response-content-type=application%2Foctet-stream'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/52/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/52/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/52/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/52/5.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/52/6.jpg'),
            },
        ],
    },
    {
        num: '51',
        homeImage: '',
        titleNormal: '九象铁军，勇往直前|九象2020年度总结表彰大会暨2021年展望大会在深圳希尔顿酒店盛大召开',
        titleSmall: '九象铁军，勇往直前|九象2020年度总结表彰大会暨2021年展望大会在深圳希尔顿酒店盛大召开',
        year: '2021',
        month: '03',
        day: '08',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/51/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/7.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/8.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/9.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/10.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/11.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://jiuxiang-guanwang.oss-cn-shenzhen.aliyuncs.com/%E5%B9%B4%E4%BC%9A.mp4?Expires=1619432387&OSSAccessKeyId=TMP.3KiuM1QAd6qAmXkZwreeqQfpavUgrPtMjXP6Xw51uHbrP3sRDjSx6a3AF3sEHLC1j6B5MMHMvBWoNeqtd8BSn1msSnMxFp&Signature=l7Rivo0TeP2J1Jv4y0bN6aEhNL0%3D&versionId=CAEQGRiBgMCukee1yBciIDRjZGM0ODUxM2QwODRjZjU5ZDRlNzhlNzYzOTYzY2Nj&response-content-type=application%2Foctet-stream'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/13.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/51/14.png'),
            },
        ],
    },
    {
        num: '50',
        homeImage: '',
        titleNormal: '九象2021全国火热招聘| 智慧工地+智慧安全+动画视频三大事业部邀您共创大业！',
        titleSmall: '九象2021全国火热招聘| 智慧工地+智慧安全+动画视频三大事业部邀您共创大业！',
        year: '2021',
        month: '02',
        day: '28',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/50/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/5.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/6.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/7.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/8.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/9.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/10.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/50/11.jpg'),
            },
        ],
    },
    {
        num: '49',
        homeImage: '',
        titleNormal: '九象使命、愿景、企业价值观2021年最新解读：公司愿景更明确，战略目标更清晰',
        titleSmall: '九象使命、愿景、企业价值观2021年最新解读：公司愿景更明确，战略目标更清晰',
        year: '2021',
        month: '02',
        day: '20',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/49/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/49/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/49/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/49/4.png'),
            },
        ],
    },
    {
        num: '48',
        homeImage: '',
        titleNormal: '九象数字2021年度主题词正式发布：九象铁军，王者之师，勇往直前，势不可挡！',
        titleSmall: '九象数字2021年度主题词正式发布：九象铁军，王者之师，勇往直前，势不可挡！',
        year: '2021',
        month: '02',
        day: '03',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/48/1.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/48/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/48/3.png'),
            },
        ],
    },
    {
        num: '47',
        homeImage: '',
        titleNormal: '来自客户的感谢信|九象企业集团级智慧工地云平台和九象团队获得中建国际高度认可',
        titleSmall: '来自客户的感谢信|九象企业集团级智慧工地云平台和九象团队获得中建国际高度认可',
        year: '2021',
        month: '01',
        day: '29',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/47/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/47/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/47/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/47/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/47/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/47/6.png'),
            },
        ],
    },
    {
        num: '46',
        homeImage: '',
        titleNormal: '重磅|国内首个深圳市绿色建造学会正式成立，热烈祝贺九象数字当选为副会长单位',
        titleSmall: '重磅|国内首个深圳市绿色建造学会正式成立，热烈祝贺九象数字当选为副会长单位',
        year: '2021',
        month: '01',
        day: '24',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/46/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/7.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/8.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/9.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/10.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/11.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/46/12.png'),
            },
        ],
    },
    {
        num: '45',
        homeImage: '',
        titleNormal: '再创历史佳绩，九象2020年度工作总结大会暨2021年度规划会议在深圳总部圆满召开',
        titleSmall: '再创历史佳绩，九象2020年度工作总结大会暨2021年度规划会议在深圳总部圆满召开',
        year: '2021',
        month: '01',
        day: '18',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/45/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/45/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/45/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/45/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/45/5.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/45/6.png'),
            },
        ],
    },
    {
        num: '44',
        homeImage: '',
        titleNormal: '【重磅】九象正式发布“AI数钢筋”软件，用手机数钢筋，效率提升10倍，免费使用',
        titleSmall: '【重磅】九象正式发布“AI数钢筋”软件，用手机数钢筋，效率提升10倍，免费使用',
        year: '2021',
        month: '01',
        day: '05',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/44/1.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://test.9xsmart.com/res/video/gangjin.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/44/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/44/4.png'),
            },
        ],
    },
    {
        num: '43',
        homeImage: '',
        titleNormal: '九象助力罗湖区2020 “党建廉建共建并赢+智慧建造品质提升”暨5G智慧工地观摩会举办',
        titleSmall: '九象助力罗湖区2020 “党建廉建共建并赢+智慧建造品质提升”暨5G智慧工地观摩会举办',
        year: '2020',
        month: '12',
        day: '21',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/43/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/43/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/43/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/43/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/43/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/43/6.png'),
            },
        ],
    },
    {
        num: '42',
        homeImage: '',
        titleNormal: '创新奔跑，九象2020年度“工程动画视频每两月一次的2佳2差”评选活动圆满收官',
        titleSmall: '创新奔跑，九象2020年度“工程动画视频每两月一次的2佳2差”评选活动圆满收官',
        year: '2020',
        month: '12',
        day: '18',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/42/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/2.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://test.9xsmart.com/res/video/2jia2cha.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/7.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/42/8.png'),
            },
        ],
    },
    {
        num: '41',
        homeImage: '',
        titleNormal: '粤港澳大湾区医疗旗舰工程，如何打造智慧工地标杆、施工安全管理标杆，九象独家曝光',
        titleSmall: '粤港澳大湾区医疗旗舰工程，如何打造智慧工地标杆、施工安全管理标杆，九象独家曝光',
        year: '2020',
        month: '12',
        day: '14',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/41/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/12.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/13.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/14.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/15.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/41/16.png'),
            },
        ],
    },
    {
        num: '40',
        homeImage: '',
        titleNormal: '长沙理工大学土木工程学院2020年度首届九象教育奖学金颁奖仪式在大礼堂隆重召开！',
        titleSmall: '长沙理工大学土木工程学院2020年度首届九象教育奖学金颁奖仪式在大礼堂隆重召开！',
        year: '2020',
        month: '11',
        day: '27',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/40/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/7.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/40/8.png'),
            },
        ],
    },
    {
        num: '39',
        homeImage: '',
        titleNormal: '使命必达，说到做到，九象珠海横琴口岸项目智慧工地系统正常运行1000天，用行动践行承诺',
        titleSmall: '使命必达，说到做到，九象珠海横琴口岸项目智慧工地系统正常运行1000天，用行动践行承诺',
        year: '2020',
        month: '11',
        day: '25',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/39/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/39/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/39/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/39/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/39/5.png'),
            },
        ],
    },
    {
        num: '38',
        homeImage: '',
        titleNormal: '热烈祝贺深圳市九象数字科技有限公司党支部成立并召开第一次全体党员会议！',
        titleSmall: '热烈祝贺深圳市九象数字科技有限公司党支部成立并召开第一次全体党员会议！',
        year: '2020',
        month: '11',
        day: '19',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/38/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/38/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/38/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/38/4.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://jiuxiang-guanwang.oss-cn-shenzhen.aliyuncs.com/%E6%B0%B8%E8%BF%9C%E8%B7%9F%E5%85%9A%E8%B5%B0vr%E4%BD%93%E9%AA%8C.mp4?Expires=1619432412&OSSAccessKeyId=TMP.3KiuM1QAd6qAmXkZwreeqQfpavUgrPtMjXP6Xw51uHbrP3sRDjSx6a3AF3sEHLC1j6B5MMHMvBWoNeqtd8BSn1msSnMxFp&Signature=QL%2FbpEOEdEmy9ha0liQPFQAujT4%3D&versionId=CAEQGRiBgMCs5.u1yBciIGZkMGExMGY3MWQxOTQzNDRiNTI5NWJkYmRlY2UzM2Yz&response-content-type=application%2Foctet-stream'
            },
        ],
    },
    {
        num: '37',
        homeImage: '',
        titleNormal: '九象智慧工地新品|龙门吊安全监控系统，龙门吊的火眼金睛，设备安全尽在“眼”中',
        titleSmall: '九象智慧工地新品|龙门吊安全监控系统，龙门吊的火眼金睛，设备安全尽在“眼”中',
        year: '2020',
        month: '11',
        day: '18',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/37/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/37/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/37/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/37/4.png'),
            },
        ],
    },
    {
        num: '36',
        homeImage: '',
        titleNormal: '九象与阿里云签署合作协议，双方将在智慧工地、智慧安全领域展开深入合作',
        titleSmall: '九象与阿里云签署合作协议，双方将在智慧工地、智慧安全领域展开深入合作',
        year: '2020',
        month: '11',
        day: '17',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/36/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/36/2.png'),
            },
        ],
    },
    {
        num: '35',
        homeImage: '',
        titleNormal: '九象工程动画助力中国铁建+中国交建拿下拉美地区最长跨海斜拉桥，中国铁建副总裁汪文忠，中国交建副总裁陈重出席并见证项目签约',
        titleSmall: '九象工程动画助力中国铁建+中国交建拿下拉美地区最长跨海斜拉桥，中国铁建副总裁汪文忠，中国交建副总裁陈重出席并见证项目签约',
        year: '2020',
        month: '11',
        day: '16',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/35/1.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://jiuxiang-guanwang.oss-cn-shenzhen.aliyuncs.com/35.mp4?Expires=1619432435&OSSAccessKeyId=TMP.3KhXxvKxodKvEXykNy1Ec4ghWmyeuiC2JzJorv6HzkLoK7eqcEse9cXa7ppWi2ckQvrHB3dJf5iRJrDYH8bQaeZmbaWnSd&Signature=nWoWEn0Hh6EA5y0OqAAfznXbZnQ%3D&versionId=CAEQGRiBgIDT6PG1yBciIGRiYjdmMmQ5MWI0YTRhZDE5ZTljOWFhZDBhNjIwMjg0&response-content-type=application%2Foctet-stream'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/4.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/6.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/7.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/8.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/9.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/10.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/11.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/12.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/13.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/14.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/15.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/16.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/17.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/18.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/19.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/35/20.png'),
            },
        ],
    },
    {
        num: '34',
        homeImage: '',
        titleNormal: '凝心聚力，砥砺前行|九象户外团建拓展活动圆满结束',
        titleSmall: '凝心聚力，砥砺前行|九象户外团建拓展活动圆满结束',
        year: '2020',
        month: '11',
        day: '10',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/34/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/34/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/34/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/34/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/34/5.png'),
            },
        ],
    },
    {
        num: '33',
        homeImage: '',
        titleNormal: '挥师入川 ，携手共进，九象成都公司正式开业迎客，立足成都，服务川渝',
        titleSmall: '挥师入川 ，携手共进，九象成都公司正式开业迎客，立足成都，服务川渝',
        year: '2020',
        month: '11',
        day: '09',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/33/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/2.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/4.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/33/7.png'),
            },
        ],
    },
    {
        num: '32',
        homeImage: '',
        titleNormal: '今天，“深圳市祁阳商会物联网建筑行业交流会”在九象深圳总部圆满举办',
        titleSmall: '今天，“深圳市祁阳商会物联网建筑行业交流会”在九象深圳总部圆满举办',
        year: '2020',
        month: '11',
        day: '07',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/32/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/32/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/32/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/32/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/32/5.png'),
            },
        ],
    },
    {
        num: '31',
        homeImage: '',
        titleNormal: '九象智慧工地新品|工地广播系统，传递安全之声，监管安全隐患',
        titleSmall: '九象智慧工地新品|工地广播系统，传递安全之声，监管安全隐患',
        year: '2020',
        month: '11',
        day: '06',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/31/1.png'),
            },
            {
                type: 'video',
                videoType: 'local',
                url: 'https://jiuxiang-guanwang.oss-cn-shenzhen.aliyuncs.com/31.mp4?Expires=1619432445&OSSAccessKeyId=TMP.3KiuM1QAd6qAmXkZwreeqQfpavUgrPtMjXP6Xw51uHbrP3sRDjSx6a3AF3sEHLC1j6B5MMHMvBWoNeqtd8BSn1msSnMxFp&Signature=URp36UpmVslmzJ8oLYJxQFAI4yU%3D&versionId=CAEQGRiBgMDln_S1yBciIGIxZTAxNDYyZGFmOTRmZmU5ZDI0YWVjYjVjOWQ2MmMx&response-content-type=application%2Foctet-stream'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/31/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/31/4.jpg'),
            },
        ],
    },
    {
        num: '30',
        homeImage: '',
        titleNormal: '九象智慧安全新品|劳保用品穿戴虚拟仿真教学，自助学习，效果显著',
        titleSmall: '九象智慧安全新品|劳保用品穿戴虚拟仿真教学，自助学习，效果显著',
        year: '2020',
        month: '11',
        day: '05',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/30/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/30/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/30/3.png'),
            },
        ],
    },
    {
        num: '29',
        homeImage: '',
        titleNormal: '九象VR安全体验-电力作业VR体验，让电力工作者更安全的点亮万家灯火',
        titleSmall: '九象VR安全体验-电力作业VR体验，让电力工作者更安全的点亮万家灯火',
        year: '2020',
        month: '10',
        day: '14',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/29/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/29/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/29/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/29/4.jpg'),
            },
        ],
    },
    {
        num: '28',
        homeImage: '',
        titleNormal: '9月，九象助力全国近15场“质量月”观摩会成功举办，为建筑施工项目质量管理保驾护航',
        titleSmall: '9月，九象助力全国近15场“质量月”观摩会成功举办，为建筑施工项目质量管理保驾护航',
        year: '2020',
        month: '09',
        day: '30',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/28/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/3.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/5.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/6.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/7.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/8.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/9.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/10.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/28/11.gif'),
            },
        ],
    },
    {
        num: '27',
        homeImage: '',
        titleNormal: '九象携科技成果亮相2020年第三届新型建筑工业化发展国际（深圳）高峰论坛暨精品展会牌',
        titleSmall: '九象携科技成果亮相2020年第三届新型建筑工业化发展国际（深圳）高峰论坛暨精品展会牌',
        year: '2020',
        month: '09',
        day: '18',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/27/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/27/2.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/27/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/27/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/27/5.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/27/6.png'),
            },
        ],
    },
    {
        num: '26',
        homeImage: '',
        titleNormal: '九象来了|今天，湖南省九象智联科技有限公司在长沙揭牌',
        titleSmall: '九象来了|今天，湖南省九象智联科技有限公司在长沙揭牌',
        year: '2020',
        month: '08',
        day: '20',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/26/1.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/2.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/5.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/6.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/26/7.jpg'),
            },
            {
                type: 'text',
                content: ['更多项目案例，可点击以下链接查看：']
            },
            {
                type: 'a',
                content: '1.抗疫战果，九象2020年上半年新签合同额同比增长90%，看看他们做了些啥！',
                href: 'https://mp.weixin.qq.com/s/T38NR59EXAbAWmpEBLsydw',
            },
            {
                type: 'a',
                content: '2.安全月完美收官！九象百人会战，助力全国20多场安全月交流观摩活动圆满举办',
                href: 'https://mp.weixin.qq.com/s/Pno-lpOqaMNz37ajMSdkIw',
            },
            {
                type: 'a',
                content: '3.成就客户，见证奇迹|15天2座工地智慧展厅拔地而起，带你揭秘聚光灯下的长圳二期（EPC）项目',
                href: 'https://mp.weixin.qq.com/s/35P1uIWvOD58d8V777LYNg',
            },
            {
                type: 'a',
                content: '4.哈尔滨工业大学-深圳工务署首个设计牵头EPC试点项目介绍-九象动画2020年7月出品',
                href: 'https://mp.weixin.qq.com/s/oNihRBVizEiEQMiNx7yh2g',
            },
        ],
    },
    {
        num: '25',
        homeImage: '',
        titleNormal: '成就客户，见证奇迹|15天2座工地智慧展厅拔地而起，带你揭秘聚光灯下的长圳二期（EPC）项目',
        titleSmall: '成就客户，见证奇迹|15天2座工地智慧展厅拔地而起，带你揭秘聚光灯下的长圳二期（EPC）项目',
        year: '2020',
        month: '08',
        day: '01',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/25/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/10.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/11.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/25/7.png'),
            },
        ],
    },
    {
        num: '24',
        homeImage: '',
        titleNormal: '团结拼搏大胆干，狠抓内功稳生产|九象2020年上半年总结会议圆满召开',
        titleSmall: '团结拼搏大胆干，狠抓内功稳生产|九象2020年上半年总结会议圆满召开',
        year: '2020',
        month: '07',
        day: '09',
        content: [{
            type: 'image',
            url: require('../assets/images/about/news/24/1.png'),
        }, ],
    },
    {
        num: '23',
        homeImage: '',
        titleNormal: '抗疫战果，九象2020年上半年新签合同额同比增长90%，看看他们做了些啥！',
        titleSmall: '抗疫战果，九象2020年上半年新签合同额同比增长90%，看看他们做了些啥！',
        year: '2020',
        month: '07',
        day: '08',
        content: [{
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/23-1.mp4'
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/23-2.mp4'
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/23-3.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/23/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/23/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/23/3.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/23/4.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/23/5.png'),
            },
        ],
    },
    {
        num: '22',
        homeImage: '',
        titleNormal: '安全月完美收官！九象百人会战，助力全国20多场安全月交流观摩活动圆满举办',
        titleSmall: '安全月完美收官！九象百人会战，助力全国20多场安全月交流观摩活动圆满举办',
        year: '2020',
        month: '06',
        day: '31',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/22/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/22/2.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/22/3.png'),
            },
        ],
    },
    {
        num: '21',
        homeImage: '',
        titleNormal: '九象智慧工地3.0版震撼发布|4大创新突破、8大模块功能升级，智慧赋能建造，科技提升效率',
        titleSmall: '九象智慧工地3.0版震撼发布|4大创新突破、8大模块功能升级，智慧赋能建造，科技提升效率',
        year: '2020',
        month: '06',
        day: '23',
        content: [{
            type: 'image',
            url: require('../assets/images/about/news/21/1.png'),
        }, ],
    },
    {
        num: '20',
        homeImage: '',
        titleNormal: '15天建成工地智慧展厅，九象展厅设计实施团队跑出“深圳速度”',
        titleSmall: '15天建成工地智慧展厅，九象展厅设计实施团队跑出“深圳速度”',
        year: '2020',
        month: '06',
        day: '15',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/20/1.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/20/2.png'),
            },
            {
                type: 'text',
                content: ['更多关于九象智慧展厅案例，可点击以下链接查看：']
            },
            {
                type: '12a',
                content: '开创新格局|九象设计中心正式成立！2019-2020工地智慧展厅（安全体验中心）精彩纷呈，点亮全国！',
            },
        ],
    },
    {
        num: '19',
        homeImage: '',
        titleNormal: '6月9日，全国政协委员、副校长杨伟军代表长沙理工大学与周亮签署了“九象教育奖学金”捐赠协议',
        titleSmall: '6月9日，全国政协委员、副校长杨伟军代表长沙理工大学与周亮签署了“九象教育奖学金”捐赠协议',
        year: '2020',
        month: '06',
        day: '12',
        content: [{
            type: 'image',
            url: require('../assets/images/about/news/19/news19.png'),
        }, ],
    },
    {
        num: '18',
        homeImage: '',
        titleNormal: '九象-动画部-2019国家优质工程奖申报视频集锦',
        titleSmall: '九象-动画部-2019国家优质工程奖申报视频集锦',
        year: '2020',
        month: '06',
        day: '11',
        content: [{
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/2020-06-11_2.mp4'
            },
            {
                type: 'text',
                content: ['九象-中建二局华为松山湖终端项目国优申报视频2019.6']
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/2020-06-11_3.mp4'
            },
            {
                type: 'text',
                content: ['九象-中铁建工广州地铁琶洲国优视频2019.6']
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/2020-06-11_1.mp4'
            },
            {
                type: 'text',
                content: ['九象-中建八大连希尔顿酒店国优视频2019.6']
            },
        ],
    },
    {
        num: '17',
        homeImage: '',
        titleNormal: '可以拖走的工地智慧展厅首次亮相深圳，助力深圳安全生产月启动仪式观摩会-九象出品',
        titleSmall: '可以拖走的工地智慧展厅首次亮相深圳，助力深圳安全生产月启动仪式观摩会-九象出品',
        year: '2020',
        month: '06',
        day: '04',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/17/2231591947409_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/1591950672923.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2251591947409_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/1/展厅全貌GIF动图.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2221591947409_.pic.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/dongtu/dongtu-2.gif'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2271591947409_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2281591947409_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/2291591947409_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/17/1.png'),
            },
            {
                type: 'text',
                content: ['更多关于九象智慧展厅案例，可点击以下链接查看：']
            },
            {
                type: '12a',
                content: '开创新格局|九象设计中心正式成立！2019-2020工地智慧展厅（安全体验中心）精彩纷呈，点亮全国！'
            },
        ],
    },
    {
        num: '16',
        homeImage: '',
        titleNormal: '九象助力| 深圳南山区住建局、深圳人才安居集团2020年安全生产月启动仪式在高新公寓项目圆满举办！',
        titleSmall: '九象助力| 深圳南山区住建局、深圳人才安居集团2020年安全生产月启动仪式在高新公寓项目圆满举办！',
        year: '2020',
        month: '06',
        day: '02',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/16/2091591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2101591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2111591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2121591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2131591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2141591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2151591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2161591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2171591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2181591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2191591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2201591934007_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/16/2211591934007_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '15',
        homeImage: '',
        titleNormal: '年会盛大召开|九象2019年度总结表彰大会暨2020年展望大会精彩瞬间',
        titleSmall: '年会盛大召开|九象2019年度总结表彰大会暨2020年展望大会精彩瞬间',
        year: '2020',
        month: '05',
        day: '30',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/15/1881591928117_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1891591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1901591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1911591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1921591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1931591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1941591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1951591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1961591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1971591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1981591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/1591951049681.png'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2001591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2011591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2021591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2031591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2041591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2051591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2061591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2071591928118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/15/2081591928118_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '14',
        homeImage: '',
        titleNormal: '5月1日，九象2020年承接的首个智慧安全教育培训展厅获东莞常务副市长喻丽君肯定',
        titleSmall: '5月1日，九象2020年承接的首个智慧安全教育培训展厅获东莞常务副市长喻丽君肯定',
        year: '2020',
        month: '05',
        day: '01',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/14/1691589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1701589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1711589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1721589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1731589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1741589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1751589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1761589512664_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1771589512665_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1781589512665_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1791589512665_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1801589512665_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/14/1811589512665_.pic_hd.jpg'),
            },
            {
                type: '12a',
                content: '开创新格局|九象设计中心正式成立！2019-2020工地智慧展厅（安全体验中心）精彩纷呈，点亮全国！'
            },
        ],
    },
    {
        num: '13',
        homeImage: '',
        titleNormal: '荣登 | 湖南省住建厅发布2019年全省智慧工地样板项目名单，九象实施的3个智慧工地项目上榜！',
        titleSmall: '荣登 | 湖南省住建厅发布2019年全省智慧工地样板项目名单，九象实施的3个智慧工地项目上榜！',
        year: '2020',
        month: '04',
        day: '27',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/13/1601589449039_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1611589449039_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1621589449039_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1631589449039_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1641589449039_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1651589449114_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1661589449114_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/13/1671589449114_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '12',
        homeImage: '',
        titleNormal: '开创新格局|九象设计中心正式成立！ 2019-2020工地智慧展厅（安全体验中心）精彩纷呈，点亮全国！',
        titleSmall: '开创新格局|九象设计中心正式成立！ 2019-2020工地智慧展厅（安全体验中心）精彩纷呈，点亮全国！',
        year: '2020',
        month: '04',
        day: '20',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/12/1301587607051_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1311587607084_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1321587607140_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1331587607178_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1341587607207_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1351587607248_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1361587607270_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1371587607294_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1381587607330_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1391587607367_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1401587607397_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1411587607432_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1421587607454_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1431587607482_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1441587607507_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1451587607538_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1461587607577_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1471587607609_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1481587607628_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1491587607662_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1501587607691_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1511587607715_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1521587607738_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1531587607769_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '11',
        homeImage: '',
        titleNormal: '客户一声令下，九象员工立马赶到湖北襄阳工地！全力以赴支持湖北工地复工复产',
        titleSmall: '客户一声令下，九象员工立马赶到湖北襄阳工地！全力以赴支持湖北工地复工复产',
        year: '2020',
        month: '04',
        day: '14',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/11/1151587028246_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1161587028263_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1171587028283_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1587368007079.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1191587028316_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1201587028336_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1211587028359_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1221587028382_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1231587028414_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1241587028442_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1251587028463_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1261587028481_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1271587028503_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/11/1281587028519_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '10',
        homeImage: '',
        titleNormal: '近日，九象收到腾讯广州总部大厦“智慧工地”整体服务中标通知书，本项目或用作微信总部！',
        titleSmall: '近日，九象收到腾讯广州总部大厦“智慧工地”整体服务中标通知书，本项目或用作微信总部！',
        year: '2020',
        month: '04',
        day: '13',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/10/871587018203_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/10/881587018266_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/10/1587371168668.jpg'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/3.mp4'
            },
            {
                type: 'text',
                content: ['腾讯滨海大厦BIM宣传片']
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/4.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/12/1587610637473.jpg'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/5.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/10/941587019232_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/10/951587019256_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/10/961587019294_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '9',
        homeImage: '',
        titleNormal: '前所未见 | 九象AI智慧安全教育培训系统全球首发，创新赋能安全，科技筑牢防线。',
        titleSmall: '前所未见 | 九象AI智慧安全教育培训系统全球首发，创新赋能安全，科技筑牢防线。',
        year: '2020',
        month: '04',
        day: '10',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/9/WechatIMG97.png'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com//res/video/2.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1587370887980.jpg'),
            },
            {
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com//res/video/1.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/991587020601_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1001587020623_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1011587020650_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1021587020667_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1031587020684_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1051587020742_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1587370352566.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1071587020785_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1081587020803_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1091587020817_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1101587020833_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1111587020848_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1121587020865_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1131587020882_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/9/1141587020900_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '8',
        homeImage: '',
        titleNormal: '九象使命、愿景、企业价值观全新升级：服务1亿工程建设者，成为行业领先、全球知名的企业，共同奋斗者实现梦想的舞台',
        titleSmall: '九象使命、愿景、企业价值观全新升级：服务1亿工程建设者，成为行业领先、全球知名的企业，共同奋斗者实现梦想的舞台',
        year: '2020',
        month: '04',
        day: '10',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/8/791587017422_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/8/811587017478_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/8/821587017478_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/8/841587017535_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/8/851587017576_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/8/861587017601_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '7',
        homeImage: '',
        titleNormal: '全国首个情景式党建VR震撼来袭|爬雪山，飞夺泸定桥，九象党建VR带你重走长征路，穿越历史。',
        titleSmall: '全国首个情景式党建VR震撼来袭|爬雪山，飞夺泸定桥，九象党建VR带你重走长征路，穿越历史。',
        year: '2020',
        month: '04',
        day: '09',
        content: [{
                type: 'video',
                videoType: 'oss',
                url: 'https://www.9xsmart.com/res/video/6.mp4'
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/7/751587008058_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/7/761587008118_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/7/771587008153_.pic_hd.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/7/781587008304_.pic_hd.jpg'),
            },
        ],
    },
    {
        num: '6',
        homeImage: '',
        titleNormal: '梦想起航 共创未来热烈庆祝九象2019年盛典暨表彰大会胜利召开！',
        titleSmall: '梦想起航 共创未来热烈庆祝九象2019年盛典暨表彰大会胜利召开！',
        year: '2019',
        month: '02',
        day: '23',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/one/nh1.jpg'),
            },
            {
                type: 'text',
                content: ['2019年注定是九象不平凡的一年!\n' +
                    '2019年2月23日，九象年会盛典在深圳皇庭酒店举行。公司120余人汇聚一堂，共谋蓝图，庆贺九象在2018所创的佳绩，为2019年吹响新征程的号角，一路冲锋，凯歌高唱!\n' +
                    '年会上，九象公司董事长兼总经理周亮先生发表“回顾与展望”的演讲，讲述了九象一路走来青春岁月的足迹!未来几年九象将迎来大发展，在正确的时间走上了一条正确的道路!只有不断创新进步才能自己掌握自己的命运！\n' +
                    '2018年，九象的收获离不开所有九象人的支持与奉献，感谢并表彰在这一年中辛勤工作，不断进步的优秀员工代表和优秀销售团队!\n' +
                    '2018已经走远，2019刚刚开始！站在新起点，迎接新希望。用饱满的工作热情、坚持不懈的奋斗，迎接新年，画出属于九象人自己的蓝图!'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/one/nh2.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/one/nh3.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/one/nh4.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/one/nh5.jpg'),
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/one/nh6.jpg'),
            },
        ],
    },
    {
        num: '5',
        homeImage: '',
        titleNormal: '3年目标1年完成，九象2018年业绩暴增150%！2018，成长，感恩！',
        titleSmall: '3年目标1年完成，九象2018年业绩暴增150%！2018，成长，感恩！',
        year: '2019',
        month: '01',
        day: '05',
        content: [{
                type: 'text',
                content: ['2018，我们风雨同舟，换来业绩攀高。2019，我们携手共进，再创辉煌。\n' +
                    '新年即将拉开序幕。今天，我代表深圳九象科技向坚守在全国各地岗位上的全体员工致以崇高的敬意和新年的祝福！向一路支持九象发展的新老客户、朋友致以最真诚的感谢！\n' +
                    '2018年，九象业绩同比增长150%，承接各类项目数量约400余个。九象三大事业版块“动画视频制作、智慧工地、安全教育培训”均取得强劲增长。\n' +
                    '动画视频：承接各类工程建设三维动画投标视频及宣传视频等项目数量200余个，在本行业内继续保持领先态势。\n'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/two/tp.jpg'),
            },
            {
                type: 'text',
                content: ['智慧工地：承接智慧工地（软件+ 硬件 整体解决方案）项目90余个，业绩大幅度增长。3-12月，九象助力全国各省市22个项目观摩交流会圆满召开。为3个国家级项目观摩会、、8个省级观摩会、11个市、区级的观摩交流活动提供了包括：智慧工地、VR安全体验、宣传片视频、AR、VR、人工智能、安全机器人、全息投影、智慧信息化产品展示等一系列综合整体解决方案。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/two/gd1.jpg'),
            },
            {
                type: 'text',
                content: ['安全教育培训：销售各类安全教育培训产品100多个，VR安全体验由于远胜同类产品的体验效果和超高的性价比，赢得广大客户信赖。产品远销北京、西安、丽江、成都、深圳、贵阳、珠海、佛山、郑州、天津、长沙、南宁、敦煌等20几个省市。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/two/gd2.jpg'),
            },
            {
                type: 'text',
                content: ['2018年，九象不断加大研发投入，率先在全国推出基于BIM的智慧工地平台2.0（升级版）、智慧建造手机APP（安卓、苹果）、VR虚拟质量样板、安全教育培训一体机、装配式施工智慧管理系统、绿色施工管理系统、智能劳务管理机器人等一些高科技产品，引领工程建设领域信息化建设进入全新的数字时代。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/two/gd3.jpg'),
            },
        ],
    },
    {
        num: '4',
        homeImage: '',
        titleNormal: '抢鲜看！九象智慧工地功能篇 新鲜出炉',
        titleSmall: '抢鲜看！九象智慧工地功能篇 新鲜出炉',
        year: '2018',
        month: '12',
        day: '21',
        content: [{
                type: 'video',
                videoType: 'oss',
                url: 'https://v.qq.com/txp/iframe/player.html?vid=x0815aa4fpv'
            },
            {
                type: 'text',
                content: ['智慧工地是啥？看看这段视频就明白了 -- 九象智慧工地功能篇新鲜出炉，看看哪个是你想要的。']
            },
        ],
    },
    {
        num: '3',
        homeImage: '',
        titleNormal: '九象2018年 “动画视频”作品 新鲜出炉，精彩岂容错过！',
        titleSmall: '九象2018年 “动画视频”作品 新鲜出炉，精彩岂容错过！',
        year: '2018',
        month: '12',
        day: '17',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/four/dh1.jpg'),
            },
            {
                type: 'text',
                content: ['九象今年智慧工地业务有点火，小伙伴们走路也带了点风。有些老顾客朋友问九象，你还做视频吗？\n' +
                    '是的，我们不仅在做，而且动画视频团队越来越强大了。九象最近还邀请了拥有10余年行业经验的导演、美术指导等精英加盟，为了提高视觉表现力我们也是拼了。\n' +
                    '我们有实锤的料，截止2018年12月15日，九象承接各类动画视频制作项目数量多达170多个，这可是在同类型公司中遥遥领先。\n' +
                    '我们有专注的心，作为工程建设领域“动画视频制作”的排头兵，九象一如既往的注重质量。\n' +
                    '2019年即将实施的“九象视频鲁班奖”创优管理制度。提高表现力和艺术水准是九象一贯的责任与追求。'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/four/dh2.jpg'),
            },
            {
                type: 'text',
                content: ['| 优秀动画项目\n' +
                    '基建类投标动画视频：巴西圣徒湾大桥\n' +
                    '总投资100亿    制作时间：2018年08月14日\n' +
                    '圣徒湾大桥是连接萨尔瓦多市区至伊塔帕里卡岛之间的交通枢纽，设计速度80km/h，为双向6车道，大桥全长12.35km，桥跨布置为37×50m+33×70m+(205+450+205)m+29×70m+106×50m。\n'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/four/dh3.jpg'),
            },
            {
                type: 'text',
                content: ['| 房建类投标动画视频\n' +
                    '昆明春之眼项目（客户已经中标）\n' +
                    '云南第一高楼    制作时间：2018年2月\n' +
                    '春之眼商业中心建设项目，地处昆明市中央核心区域，占地面积约4万平米，总建筑面积约60万平米，由2栋超高层摩天大厦与高端商业中心组成。\n'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/four/dh4.jpg'),
            },
            {
                type: 'text',
                content: ['| 业主地产3D宣传片\n' +
                    '绿景地产魅力樟洋旧改项目\n' +
                    '客户名称：绿景地产\n' +
                    '制作时间：2018年10月25日\n' +
                    '在美国发展生物医药产业的阿叔回家乡祭祖，侄子阿伟和爸爸一起去机场接阿叔，在侄子阿伟、哥哥蔡书记、吴伯以及小阿妹的引领下参观改造后的家乡，感叹家乡的巨变。\n'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/four/dh5.jpg'),
            },
        ],
    },
    {
        num: '2',
        homeImage: '',
        titleNormal: '2018年全国“绿色智慧建造”观摩会',
        titleSmall: '2018年全国“绿色智慧建造”观摩会',
        year: '2018',
        month: '10',
        day: '17',
        content: [{
                type: 'video',
                videoType: 'oss',
                url: 'https://v.qq.com/txp/iframe/player.html?vid=m07503460z5'
            },
            {
                type: 'text',
                content: ['全球最大面板厂武汉京东方宣传片带你看最新黑科技--九象出品。']
            },
        ],
    },
    {
        num: '1',
        homeImage: '',
        titleNormal: '金秋九月，九象“智慧工地”硕果累累，黑科技接踵而来！',
        titleSmall: '金秋九月，九象“智慧工地”硕果累累，黑科技接踵而来！',
        year: '2018',
        month: '09',
        day: '26',
        content: [{
                type: 'image',
                url: require('../assets/images/about/news/five/bgy.jpg'),
            },
            {
                type: 'text',
                content: ['金秋9月，九象“智慧工地”成功签约碧桂园佛山顺德总部三期、中建八局中山大学附属第一（广州南沙）医院EPC建设项目、中铁建工华润南昌江旅青山湖商业旅游综合体、招商局前海经贸中心三期等多个项目。']
            },
            {
                type: 'text',
                content: ['佛山顺德 碧桂园总部三期项目\n' +
                    '本项目为碧桂园集团总部三期项目，碧桂园作为中国新型城镇化进程的身体力行者，是全球绿色生态智慧城市的建造者，对产品的质量与服务要求高。经过长达1个月的产品测试、多轮比拼角逐，凭借过硬的技术实力、超高的性价比、优质的服务，九象终于牵手碧桂园集团在本项目“智慧工地”应用方面展开全方位的合作。\n'
                ]
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/five/ns.jpg'),
            },
            {
                type: 'text',
                content: ['中山大学附属第一（广州南沙）医院EPC建设项目\n' +
                    '该项目是整个大湾区面积最大、级别最高的公共医疗综合服务配套项目。建筑面积498818平方米，项目造价38亿元。建成后将成为与粤港澳大湾区建设展相配套、辐射粤港澳乃至东南亚的高水平三级甲等综合医院。\n'
                ]
            },
            {
                type: 'text',
                content: ['九象将为本项目提供智慧工地软件平台建设、硬件安装施工、VR安全体验、实名制安全教育培训、项目观摩策划等一体化综合解决方案。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/five/zsj.jpg'),
            },
            {
                type: 'text',
                content: ['招商局前海经贸中心三期项目\n' +
                    '由招商局集团投资建设，项目位于深圳市前海自贸区，总建筑面积5.94万平米，项目由意大利著名建筑大师伦佐.皮亚诺（普利兹克奖得主，代表作品蓬皮杜艺术中心、江南布衣总部等）设计，设计单位为悉地国际有限公司。\n'
                ]
            },
            {
                type: 'text',
                content: ['九象将为本项目提供智慧工地软件平台建设、硬件安装施工等整体解决方案。']
            },
            {
                type: 'image',
                url: require('../assets/images/about/news/five/jx.jpg'),
            },
            {
                type: 'text',
                content: ['华润南昌江旅青山湖商业旅游综合体项目\n' +
                    '九象自主研发的“人脸识别劳务实名制门禁管理系统”，通过“人脸识别技术 + 一卡通”等多种识别方式，在工地大门出入口安装智能识别设备，自动统计人数上传至政府监管平台、云筑网、智慧工地云平台等管理系统，辅助项目日常工种用工统计及管理。\n'
                ]
            },
        ],
    },
]

export default newsList;